module.exports = __webpack_public_path__ + "static/img/equipmentIntroduction.4d1c906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/en/equipmentIntroduction.png
// module id = eB/T
// module chunks = 1